export const SET_SHOPS = 'SET_SHOPS';
export const SET_SHOP = 'SET_SHOP';
export const ADD_SHOP = 'ADD_SHOP';
export const UPDATE_SHOP = 'UPDATE_SHOP';
export const REMOVE_SHOP = 'REMOVE_SHOP';
export const CLEAR_SHOP = 'CLEAR_SHOP';
export const CLEAR_SHOPS = 'CLEAR_SHOPS';
